export default __webpack_public_path__ + "static/media/ded-contact-slack.a65d1ea6.svg";